<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #list>
        <NoneChevronExpansionPanel>
          <template #header>
            <div class="headerAreaStyle d-flex align-center px-9">
              <div class="titleStyle">
                {{ $t('storage.storage_display-stock') }}
              </div>
              <div class="px-5">
                <v-select
                  v-model="storageType"
                  :items="storageIdNameList"
                  item-text="label"
                  item-value="value"
                  filled
                  dense
                  multiple
                  outlined
                  class="original-selectbox headerAreaselectbox"
                  hide-details
                  :placeholder="$t('common.input_unselected_2')"
                  :height="inputFormStyle.inputItemHeight"
                >
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                      <v-list-item-action class="ma-0 mr-2">
                        <v-checkbox
                          :input-value="active"
                          off-icon="mdi-checkbox-marked"
                          :class="{ isOff: !active }"
                          :ripple="false"
                          dense
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-row no-gutters>
                            <span>{{ item.label }}</span>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </div>
              <NormalButton
                :text="$t('common.common_csv-download')"
                btnClass="pa-2"
                height="32px"
                width="150px"
                textSize="14px"
                class="csv-download-button"
                @click="csvDownload"
              />
            </div>
          </template>
          <template #content>
            <ProductInfo
              :search="productSearchInfo"
              :storageType="storageType"
              :isRegist="true"
            />
          </template>
        </NoneChevronExpansionPanel>
      </template>
    </Master>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { Master } from '@/components/layouts'
import ProductInfo from '@/components/layouts/ProductInfo/ProductStocks/ProductInfo'
import { NoneChevronExpansionPanel } from '@/components/items'
import { storageUtil } from '@/util'
import { i18n } from '@/main.js'
import NormalButton from '@/components/items/Buttons/NormalButton'

export default {
  components: {
    Master,
    ProductInfo,
    NoneChevronExpansionPanel,
    NormalButton
  },
  data: () => {
    return {
      pageTitle: i18n.tc('common.common_stock-list'),
      inputFormStyle: {
        titleCols: 3,
        contentsCols: 9,
        inputItemHeight: '32px'
      },
      productData: {},
      itemKey: 'productId',
      storageType: [],
      productSearchInfo: {
        category: ''
      },
      productList: [],
      productSupplierNameList: [],
      storageIdNameList: []
    }
  },
  methods: {
    ...mapActions('Storage', ['csvDownloadStockList']),
    async init() {
      this.$refs.productInfo.init()
    },
    selectCategory(...args) {
      const [categoryId] = args
      this.productSearchInfo.category = categoryId
    },
    async csvDownload() {
      const params =
        this.storageType.length === 0
          ? {}
          : {
              storageIds: this.storageType.join(',')
            }
      const result = await this.csvDownloadStockList(params)
      if (result) {
        alert(
          this.$t('storage.storage_csv-download-stock-list-send-mail-message')
        )
      }
    }
  },
  async mounted() {
    const isHideUnusedStorage = true
    this.storageIdNameList = await storageUtil
      .getStorageIdNameList(isHideUnusedStorage)
      .then((list) => list.data)
  },
  watch: {
    productSearchInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.productSearch(newVal)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.titleStyle {
  font-size: 18px;
  font-weight: bold;
}
.headerAreaStyle {
  height: 70px;
}
.headerAreaselectbox {
  width: 322px;
  ::v-deep fieldset {
    border: none !important;
  }
}
.isOff {
  ::v-deep .mdi-checkbox-marked {
    color: #dddddd;
  }
}
.csv-download-button {
  position: absolute;
  right: 25px;
}
</style>
